import React, { useEffect, useState } from 'react';
import { EventAvailableOutlined } from '@mui/icons-material';
import { Box } from '@mui/material';
import Formulario from 'components/public/Formulario/Formulario';
import Spinner from 'components/public/Spinner/Spinner';
import NoResponse from 'pages/auxiliares/NoResponse';
import NotAllowed from 'pages/auxiliares/NotAllowed';
import { useSelector, useDispatch } from 'react-redux';
import { useError } from 'services/ErrorContext';
import { datosGenero } from 'utils/formData';
import { IFormulario, ISelectOptions } from 'utils/models/interfaces';
import { RootState, AppDispatch } from 'utils/redux/store/store';
import { crearOpcionesTipos } from 'utils/utilities';
import { fetchGeneros } from 'utils/redux/features/generosSlice';
import { TipoGenericoRequest } from 'utils/models/types';
import { registroGenero } from 'services/servicioPost';
import { anchoMaxLogueado } from 'utils/constants';

const Generos = () => {
  const [mensajeExito, setMensajeExito] = useState('');
  const { generos, loadingGeneros, errorGeneros } = useSelector((state: RootState) => state.generos);
  const { error, setError, clearError, loading, setLoading } = useError();
  const dispatch = useDispatch<AppDispatch>();
  const opcionesGenero: ISelectOptions[] = crearOpcionesTipos(generos, 'Tipos');

  useEffect(() => {
    dispatch(fetchGeneros());
  }, [dispatch]);

  const handleVolver = () => {
    setMensajeExito('');
  };

  const error401 = errorGeneros?.includes('permisos');

  async function handleSubmit(data: IFormulario): Promise<void> {
    clearError();
    const requestAltaGenero: TipoGenericoRequest = {
      Nombre: data.Nombre,
    };
    try {
      await registroGenero(requestAltaGenero, setError, setLoading);
      setMensajeExito('¡Nuevo género registrado con éxito!');
    } catch (error) {
      console.error('Error de registro:', error);
    }
  }

  return (
    <Box maxWidth={anchoMaxLogueado} mx="auto">
      {loadingGeneros ? (
        <Spinner />
      ) : errorGeneros ? (
        error401 ? (
          <NotAllowed />
        ) : (
          <NoResponse />
        )
      ) : (
        <Formulario
          campos={datosGenero}
          titulo="Agregar Género"
          textoBoton="Agregar"
          onSubmit={handleSubmit}
          datos={opcionesGenero}
          onVolver={handleVolver}
          mensajeExito={mensajeExito}
          mensajeError={error}
          loading={loading}
          iconoBoton={EventAvailableOutlined}
        />
      )}
    </Box>
  );
};

export default Generos;
